<div class="card">
  <div class="d-flex justify-space-between align-items-center header-padding">
    <span class="card-title">{{ cardHeader }}</span>
    <div class="d-flex gap-10">
      <div class="sb-border">
        <mat-form-field>
          <mat-label>Sort By</mat-label>
          <select matNativeControl disabled>
            <option value=""></option>
          </select>
        </mat-form-field>
      </div>
      <div class="sb-border">
        <mat-form-field>
          <mat-label>Filter By</mat-label>
          <select matNativeControl disabled>
            <option value=""></option>
          </select>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="accordian-table">
    <mat-accordion displayMode="flat" class="mat-table" [multi]="true">
      <section *ngIf="panelData?.length > 0" class="mat-elevation-z2 mat-header-row">
        <ng-container *ngFor="let key of getKeys(panelData[0]?.header)">
          <span class="mat-header-cell">{{ key }}</span>
        </ng-container>
      </section>

      <mat-expansion-panel *ngFor="let config of panelData">
        <mat-expansion-panel-header class="mat-row">
          <ng-container *ngFor="let key of getKeys(config?.header)">
            <span class="mat-cell">{{ config.header[key] }}</span>
          </ng-container>
        </mat-expansion-panel-header>

        <section *ngFor="let child of config?.children" class="mat-children-row">
          <ng-container *ngFor="let key of getKeys(child)">
            <span class="mat-cell" *ngIf="key !=='Image'">{{ child[key] }}</span>
            <img class="mat-cell" alt="img" [src]="child[key]" *ngIf="key ==='Image'" />
          </ng-container>

          <span class="icon-cell" (click)="openPopover(child)" *ngIf="tabType === 'features'">
            <img alt="arrow" src="../../../../assets/images/arrow_menu_open.svg" />
          </span>
        </section>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>